export default __webpack_public_path__ + "static/media/washingtonFootballClubVideo-2x.3c0b06c5.jpg";